import { type FC } from "react";

import { Flex, Paper } from "@mantine/core";
import { Button } from "@snapchat/snap-design-system";
import { Colors, Sizes, WarningIcon } from "@snapchat/snap-design-system-icons";

import { container, content, footer } from "./MonetizationTosWarning.module.css";
import { TosWarningContent, TosWarningTitle, ViewTerms } from "./messages.generated";

interface MonetizationTosWarningProps {
    dataLoading: boolean;
    triggerTosModal: () => void;
    showFooterBg?: boolean;
}

export const MonetizationTosWarning: FC<MonetizationTosWarningProps> = ({
    dataLoading,
    triggerTosModal,
    showFooterBg = true,
}) => {
    return (
        <Paper withBorder radius="md" className={container}>
            <Flex direction={showFooterBg ? "column" : "row"} gap="md">
                <Flex className={content} gap="xs">
                    <WarningIcon fill={Colors.Orange.V200} size={Sizes.Large} order={showFooterBg ? 0 : 1} />
                    <Flex direction="column" gap="xs">
                        <h3 className={"heading-h600"}>
                            <TosWarningTitle />
                        </h3>
                        <p className={"paragraph-p300"}>
                            <TosWarningContent />
                        </p>
                    </Flex>
                </Flex>

                <Flex className={footer} data-show-footer-bg={showFooterBg || undefined}>
                    <Button type="primary" onClick={dataLoading ? undefined : triggerTosModal}>
                        <ViewTerms />
                    </Button>
                </Flex>
            </Flex>
        </Paper>
    );
};
